const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permissions: state => state.user.permissions,
  addRouters: state => state.permission.addRouters,
  menu: state => state.user.menu,
  isCollapse: state => state.common.isCollapse,
  exam: state => state.exam.exam,
  subject: state => state.exam.subject,
  cards: state => state.exam.cards,
  examRecord: state => state.exam.examRecord,
  practice: state => state.practice.practice,
  practiceRecord: state => state.practice.practiceRecord,
  practiceSubject: state => state.practice.practiceSubject,
  course: state => state.course.course,
  sysConfig: state => state.sysConfig.sysConfig,
  tenantCode: state => state.user.tenantCode,
  incorrectRecord: state => state.exam.incorrectRecord,
  userInfo: state => state.user.userInfo,
  stateInfo: state => state.stateInfo.stateInfo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js